import { isCorrectPhoneObject } from './isCorrectPhoneObject';
export var cropPhone = function cropPhone(_ref) {
  var phone = _ref.phone,
    isFullPhone = _ref.isFullPhone;
  if (!phone || !isCorrectPhoneObject(phone)) {
    return '';
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var numeric = phone.number;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var countryCode = phone.countryCode;
  countryCode = countryCode === '7' || countryCode === '8' ? '+7' : countryCode;
  numeric = numeric.length === 7 ? numeric.replace(/(^\d{3})(\d{2})(\d{2}$)/, '$1 $2 $3') : numeric;
  numeric = isFullPhone ? numeric : numeric.replace(/\s?\d{2}$/, ' …');
  return "".concat(countryCode, " ").concat(phone.code, " ").concat(numeric);
};